import { useState } from "react";
import { HashLink } from 'react-router-hash-link';
import { Link, useHistory, useLocation } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import './header.scss'
const Header = () => {
  const currentYear = new Date().getFullYear();
  const [showsidebar, setShowSidebar] = useState(false);
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;

  const router = useLocation();
  const history = useHistory();

  const handleShowSidebar = () => setShowSidebar(true);
  const handleClose = () => setShowSidebar(false);


  const handleClick = (e, hash) => {
    e.preventDefault(); 
    setShowSidebar(false); 

    setTimeout(() => {
      history.push(`/#${hash}`);
      const targetElement = document.getElementById(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.error(`Element with ID '${hash}' not found`);
      }
    }, 1000); 
  };
  return (
    <>
      <section className={router.pathname === "/headofmarketing" || router.pathname === "/marketingoperationsmanager" || router.pathname === "/headofprandcommunications" || router.pathname === "/headofcommunity" || router.pathname === "/supportspecialist" ? "main-navbar specialnavbar" : "main-navbar"}>
        <div class="custom-container">
          <nav class="navbar navbar-expand-xl">
            <Link class="navbar-brand" to="/">
            {
              router.pathname === "/headofmarketing" || router.pathname === "/marketingoperationsmanager" || router.pathname === "/headofprandcommunications" || router.pathname === "/headofcommunity" || router.pathname === "/supportspecialist" ? <>   <img src="\footerlogo.svg" alt="logoimg" className="logoimg" /></> : <>   <img src="\logo.svg" alt="logoimg" className="logoimg" /></>
            }
           
            </Link>
            <button class="navbar-toggler" onClick={handleShowSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                  <path d="M1 11H19M1 6H19M1 1H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
            <div class="collapse navbar-collapse mobile-none" id="navbarSupportedContent">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <HashLink to="/" class="nav-link" style={
                    isActive("")
                      ? {
                        fontFamily: "cmedium"
                      }
                      : {}
                  }> <a>Home</a></HashLink>
                </li>
                <li class="nav-item">
                  <HashLink to="/#specialties" class="nav-link" style={
                    isActive("#specialties")
                      ? {
                        fontFamily: "cmedium"
                      }
                      : {}
                  }><a >Our Specialties</a></HashLink>
                </li>
                <li class="nav-item">
                  <HashLink to="/#choose" class="nav-link" style={
                    isActive("#choose")
                      ? {
                        fontFamily: "cmedium"
                      }
                      : {}
                  }> <a>Why Choose Us</a></HashLink>
                </li>
                <li class="nav-item">
                  <HashLink class="nav-link" to="/#contact" style={
                    isActive("#contact")
                      ? {
                        fontFamily: "cmedium"
                      }
                      : {}
                  }><a>Contact Us</a></HashLink>
                </li>
                <li class="nav-item">
                  <Link class="nav-link" to="/career" style={router.pathname == "/career" ? { fontFamily: "cmedium" } : {}}><a>Career</a></Link>
                </li>

              </ul>
              <div class="d-flex tusfssfsuxfufsu">
                <div className="icons">
                  <HashLink className="btn-common" to="/#contact">contact us</HashLink>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </section>
      <div className="mobile-menu">
        <Offcanvas placement="top" show={showsidebar} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img src="\footerlogo.svg" alt="logoimg" className="logoimg" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <HashLink href="#home" onClick={(e) => handleClick(e, 'home')} class="nav-link" style={
                  isActive("#home")
                    ? {
                      color: "#6234FC",
                    }
                    : {}
                }> <a>Home</a></HashLink>
              </li>

              <li class="nav-item">
                <HashLink href="#specialties" onClick={(e) => handleClick(e, 'specialties')} class="nav-link" style={
                  isActive("#specialties")
                    ? {
                      color: "#6234FC"
                    }
                    : {}
                }> <a>Our Specialties</a></HashLink>
              </li>
              <li class="nav-item">
                <HashLink href="#choose" onClick={(e) => handleClick(e, 'choose')} class="nav-link" style={
                  isActive("#choose")
                    ? {
                      color: "#6234FC"
                    }
                    : {}
                }><a>Why Choose Us</a></HashLink>
              </li>
              <li class="nav-item">
                <HashLink href="#contact" onClick={(e) => handleClick(e, 'contact')} class="nav-link" style={
                  isActive("#contact")
                    ? {
                      color: "#6234FC"
                    }
                    : {}
                }> <a >Contact Us</a></HashLink>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/career" style={router.pathname == "/career" ? { fontFamily: "cmedium" } : {}}><a>Career</a></Link>
              </li>
            </ul>
            <div className="offlast">
              <div className="socials">
                <a href="https://www.linkedin.com/company/elinnovation/" target="_blank" className="scoialpara">
                  <img src="\assets\LinkedIn.svg" alt="socialimg" className="socialimg" />
                  LinkedIn
                </a>
              </div>
              <p className="offlastpara">
                Copyright © {currentYear} Elinnovation. All Rights Reserved.
              </p>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  )
}

export default Header